/* eslint-disable no-console */
console.log('galleryView.js');
/* eslint-enable no-console */
